import { useEffect, FC } from 'react';
import Modal from 'react-modal';
import { ModalButton, useModalContext } from '@context/Modal';
import * as styles from './styles';
import { useFocusable, FocusContext } from '@noriginmedia/norigin-spatial-navigation';
import FocusableIconButton from '../FocusableIconButton';

const modalStyle = {
  overlay: {
    backgroundColor: 'none'
  },
  content: {
    inset: 0,
    border: 'none',
    padding: 0,
    right: 0,
    left: 0,
    top: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.8)'
  }
};

const FocusableModal: FC = () => {
  const { ref, focusKey, setFocus } = useFocusable({
    isFocusBoundary: true,
    focusKey: 'MODAL'
  });

  const { visible, modalInfo } = useModalContext();

  useEffect(() => {
    setFocus(modalInfo.initialFocusKey);
    return () => {
      setFocus(modalInfo.exitFocusKey);
    };
  }, [setFocus, modalInfo]);

  return (
    <Modal style={modalStyle} isOpen={visible}>
      <FocusContext.Provider value={focusKey}>
        <div css={styles.container} ref={ref}>
          <div css={styles.content}>
            <p css={styles.title}>{modalInfo.title}</p>
          </div>
          <div css={styles.buttonContainer}>
            {modalInfo.buttons.map((item: ModalButton, index: number) => (
              <FocusableIconButton
                key={index}
                iconType={item.iconType}
                onEnterPress={item.onClick}
                focusKey={item.focusKey}
              >
                {item.text}
              </FocusableIconButton>
            ))}
          </div>
        </div>
      </FocusContext.Provider>
    </Modal>
  );
};

export default FocusableModal;
